var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx } from "react/jsx-runtime";
/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
import { IMaskInput } from 'react-imask';
import { TextField } from '@mui/material';
import { useController } from 'react-hook-form';
export var MaskedInput = React.forwardRef(function (props, ref) {
    var onChange = props.onChange, mask = props.mask, other = __rest(props, ["onChange", "mask"]);
    var maskValue = Array.isArray(mask) ? __spreadArray([], mask, true) : mask;
    return (_jsx(IMaskInput, __assign({}, other, { mask: maskValue, inputRef: ref, onAccept: function (value) {
            return onChange({ target: { name: props.name, value: value } });
        }, overwrite: true })));
});
var MaskedTextFieldControl = function (_a) {
    var name = _a.name, control = _a.control, mask = _a.mask, disabled = _a.disabled, required = _a.required, textFieldProps = __rest(_a, ["name", "control", "mask", "disabled", "required"]);
    var _b = useController({
        name: name,
        control: control,
    }), field = _b.field, error = _b.fieldState.error;
    return (_jsx(TextField, __assign({}, textFieldProps, field, { disabled: disabled, required: !disabled && required, "data-testid": name, InputProps: {
            inputComponent: MaskedInput,
            inputProps: { mask: mask },
        }, error: !!error, fullWidth: true, sx: { mt: '16px', mb: '8px' }, helperText: error ? error.message : textFieldProps.helperText })));
};
export default MaskedTextFieldControl;
